module.exports = __webpack_public_path__ + "img/icon_fast_delivery_c@2x.654e7f2.webp";